import { Link } from 'react-router-dom'
import { SITE } from '../data/site.js'
import Icon from './Icon.jsx'
import Logo from './Logo.jsx'

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-grid">
        <div className="footer-brand">
          <Logo size={44} />
          <p>
            Factory-direct shower screens, toughened glass panels and premium hardware.
            All glass certified to AS/NZS 2208.
          </p>
          <p className="footer-abn">{SITE.legalName} · {SITE.abn}</p>
        </div>
        <div>
          <h4>Shop</h4>
          <Link to="/shop/shower-screens">Shower Screens</Link>
          <Link to="/shop/hardware">Hardware</Link>
          <Link to="/shop/glass-panels">10mm Frameless Glass Panels</Link>
          <Link to="/shop/tools-accessories">Tools & Accessories</Link>
          <Link to="/shop/wardrobe-doors">Wardrobe Doors</Link>
        </div>
        <div>
          <h4>Help</h4>
          <Link to="/how-to-buy">How to Buy</Link>
          <Link to="/diy-guide">DIY Guide</Link>
          <Link to="/faq">FAQ</Link>
          <Link to="/shipping">Shipping & Returns</Link>
          <Link to="/gallery">Gallery</Link>
          <Link to="/about">About Us</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms & Conditions</Link>
        </div>
        <div>
          <h4>Contact</h4>
          <a href={SITE.phoneHref}><Icon name="phone" size={15} /> {SITE.phone}</a>
          <a href={`mailto:${SITE.email}`}><Icon name="mail" size={15} /> {SITE.email}</a>
          <a href={SITE.mapsUrl} target="_blank" rel="noreferrer"><Icon name="pin" size={15} /> {SITE.address}</a>
          <span><Icon name="clock" size={15} /> {SITE.hours}</span>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          © {new Date().getFullYear()} {SITE.legalName}. All prices in AUD, excluding GST.
        </div>
      </div>
    </footer>
  )
}
